export default {
  application: (id) => `hrmis/leave_application?application_code=${id}`,
  HandOverApprovals: "hrmis/leave_application/HandOverApprovals",
  patchHandover: "hrmis/leave_application/HandoverOperations",
  handoverTasks: "hrmis/leave_application/handover-tasks",
  handoverReasons: "hrmis/leave_application/handover-reasons",
};
